<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
</script>
<template>
  <v-app-bar app flat height="155" class="pa-0 public-app-header header-print" color="white">
    <v-container fluid class="pa-0">
      <v-row no-gutters class="pb-3" justify="center">
        <v-col cols="12" md="11" lg="10" xl="9" class="text-left pl-2">
          <v-img
            height="100"
            width="700"
            src="@/assets/images/mfp.svg"
            style="flex-grow: unset; cursor: pointer"
            @click="router.push({ name: 'startPage' })"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>
